import "./divider.css.ts.vanilla.js";
var r = {
    default: "o0dvt10",
    inverse: "o0dvt11"
};
export { r as variants };
